import { useTranslation } from 'react-i18next';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import { formatCurrency } from 'src/shared/utils/currency';
import { getLocaleFromIsoCode } from 'src/shared/utils/locale';
import { useGetUserHoldingQuery } from 'src/shared/api/holding';
import { SaldoItem, type SaldoItemStatus } from '../SaldoItem';

type SaldoStatsProps = {
  lowOnFundsThreshold: number;
  currentBalance: number;
  status?: SaldoItemStatus;
};

export const SaldoStats = ({ currentBalance, lowOnFundsThreshold, status }: SaldoStatsProps) => {
  const { t } = useTranslation('overview');
  const { data: userHolding } = useGetUserHoldingQuery();

  const formatCompanyCurrency = formatCurrency(
    getLocaleFromIsoCode(userHolding?.territory?.isoCode),
    userHolding?.territory?.currency
  );

  return (
    <>
      <SaldoItem
        status={status}
        saldo={formatCompanyCurrency(currentBalance)}
        label={t('saldo actual')}
        Icon={AccountBalanceWalletOutlinedIcon}
        tooltipProps={{
          title: t('tooltip.saldo actual')
        }}
      />
      <SaldoItem
        status={status}
        saldo={formatCompanyCurrency(lowOnFundsThreshold)}
        label={t('saldo alerta')}
        Icon={NotificationsOutlinedIcon}
        tooltipProps={{
          title: t('tooltip.saldo alerta')
        }}
      />
    </>
  );
};
